module.exports = __webpack_public_path__ + "img/4.57689dc5.jpg";